/**
 * When downgrading advanced → basic, the update must explicitly clear
 * advanced-only relations or they remain on the same scopeOfWorkUid.
 */
export function buildScopeOfWorkPatchPayload(
  scopePayload: Record<string, unknown>,
  jobType?: string | null,
): Record<string, unknown> {
  const isBasic = jobType === "basic";

  if (!isBasic) {
    return scopePayload;
  }

  return {
    ...scopePayload,
    areas: [],
    otherAreas: [],
    additionalObjects: [],
    specialRequests: [],
  };
}
